<template>
    <Bttn
        icon="share"
        :icon-only="iconOnly"
        title="Share"
        v-bind="$attrs"
        @click="showModal = true"
    >
        <slot>Share</slot>
    </Bttn>
    <ShareFriendsModal
        v-if="showModal"
        :item-id="itemId"
        :item-type="itemType"
        @close="showModal = false"
    />
</template>

<script>
import ShareFriendsModal from "js/components/modals/ShareFriendsModal";

export default {
    name: "Share",
    components: { ShareFriendsModal },
    inheritAttrs: false,
    props: {
        itemId: {
            type: Number,
            default: null,
        },
        itemType: {
            type: String,
            default: null,
        },
        iconOnly: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
};
</script>
